import { useQuery } from "@apollo/client";
import { ArtifactType, DecisionState } from "types/graphql-schema";

import ArtifactIcon from "@apps/artifact/components/artifact-icon";
import DraftLabel from "@components/draft-label/draft-label";
import GoalVisibilityIcon from "@components/goal-visibility-icon/goal-visibility-icon";

import getWysiwygArtifactQuery from "./graphql/get-wysiwyg-artifact-query";

const WysiwygArtifactIcon = ({
  syncedArtifact,
  node,
}: {
  syncedArtifact: any;
  node: any;
}) => {
  const { data } = useQuery(getWysiwygArtifactQuery, {
    fetchPolicy: "cache-only", // rely only on cached content to render this view
    variables: { artifactId: Number(syncedArtifact.id) },
  });
  const artifactTypeName = node.type.name;
  const isActionItem = artifactTypeName === ArtifactType.ActionItem;
  const isDecision = artifactTypeName === ArtifactType.Decision;
  const isGoal = artifactTypeName === ArtifactType.Goal;
  const isDocument = artifactTypeName === ArtifactType.Document;
  const isFeedback = artifactTypeName === ArtifactType.Feedback;
  const artifact = data?.artifact || syncedArtifact;

  return isActionItem ? (
    <span className="flex items-start gap-1" contentEditable={false}>
      <div className="mt-0.5">
        <ArtifactIcon artifact={artifact} size="4" />
      </div>
    </span>
  ) : isDecision ? (
    <span className="flex items-start gap-1" contentEditable={false}>
      <span className="text-emerald-600 mt-0.5" contentEditable={false}>
        <ArtifactIcon artifact={artifact} size="4" />
      </span>
      {artifact.decisionState === DecisionState.Draft && (
        <div>
          <DraftLabel />
        </div>
      )}
    </span>
  ) : isDocument ? (
    <span className="text-gray-500 mt-0.5" contentEditable={false}>
      <ArtifactIcon artifact={artifact} size="4" />
    </span>
  ) : isFeedback ? (
    <span className="text-gray-500 mt-0.5" contentEditable={false}>
      <ArtifactIcon artifact={artifact} size="4" />
    </span>
  ) : artifactTypeName === ArtifactType.Recognition ? (
    <span className="text-amber-500 mt-0.5" contentEditable={false}>
      <ArtifactIcon artifact={artifact} size="4" />
    </span>
  ) : isGoal ? (
    // Draft pill is rendered separately on the right side via ArtifactInfos
    // so it sits aligned with the title text rather than crowding the icon.
    <div className="flex items-start gap-1">
      <div className="mt-0.5">
        <ArtifactIcon artifact={artifact} size="4" />
      </div>
      <GoalVisibilityIcon
        goalVisibility={artifact.goalVisibility}
        size="4"
        showOnlyIfPrivate
        className="mt-0.5"
      />
    </div>
  ) : null;
};

export default WysiwygArtifactIcon;
